/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  ChangeTargetParams,
  CreateDriveOnReportParams,
  DriveOnAuthTemplateNotFoundException,
  DriveOnDisplayableTaskDto,
  DriveOnDriverInputPatchDto,
  DriveOnNearestTargetsDto,
  DriveOnReportDto,
  DriveOnStatusDto,
  DriveOnTargetAlreadyAssignedException,
  DriveOnTargetIdentificationException,
  DriveOnTargetsDto,
  EventusResponseDto,
  EventusTaskDto,
  GetDriveOnReportsParams,
  GetTargetsWithDistanceParams,
  GetTasksParams,
  PatchDriverInputParams
} from '../../model'



export const updateTasks = (
    eventusTaskDto: EventusTaskDto[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EventusResponseDto>> => {
    
    
    return axios.default.post(
      `/api/eventus`,
      eventusTaskDto,options
    );
  }



export const getUpdateTasksMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTasks>>, TError,{data: EventusTaskDto[]}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateTasks>>, TError,{data: EventusTaskDto[]}, TContext> => {
    
const mutationKey = ['updateTasks'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTasks>>, {data: EventusTaskDto[]}> = (props) => {
          const {data} = props ?? {};

          return  updateTasks(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTasksMutationResult = NonNullable<Awaited<ReturnType<typeof updateTasks>>>
    export type UpdateTasksMutationBody = EventusTaskDto[]
    export type UpdateTasksMutationError = AxiosError<unknown>

    export const useUpdateTasks = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTasks>>, TError,{data: EventusTaskDto[]}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateTasks>>,
        TError,
        {data: EventusTaskDto[]},
        TContext
      > => {

      const mutationOptions = getUpdateTasksMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getDriveOnReports = (
    params: GetDriveOnReportsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DriveOnReportDto[]>> => {
    
    
    return axios.default.get(
      `/api/driveon/report`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetDriveOnReportsQueryKey = (params: GetDriveOnReportsParams,) => {
    return [`/api/driveon/report`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDriveOnReportsQueryOptions = <TData = Awaited<ReturnType<typeof getDriveOnReports>>, TError = AxiosError<unknown>>(params: GetDriveOnReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReports>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDriveOnReportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriveOnReports>>> = ({ signal }) => getDriveOnReports(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDriveOnReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getDriveOnReports>>>
export type GetDriveOnReportsQueryError = AxiosError<unknown>


export function useGetDriveOnReports<TData = Awaited<ReturnType<typeof getDriveOnReports>>, TError = AxiosError<unknown>>(
 params: GetDriveOnReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriveOnReports>>,
          TError,
          Awaited<ReturnType<typeof getDriveOnReports>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriveOnReports<TData = Awaited<ReturnType<typeof getDriveOnReports>>, TError = AxiosError<unknown>>(
 params: GetDriveOnReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriveOnReports>>,
          TError,
          Awaited<ReturnType<typeof getDriveOnReports>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriveOnReports<TData = Awaited<ReturnType<typeof getDriveOnReports>>, TError = AxiosError<unknown>>(
 params: GetDriveOnReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReports>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDriveOnReports<TData = Awaited<ReturnType<typeof getDriveOnReports>>, TError = AxiosError<unknown>>(
 params: GetDriveOnReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReports>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDriveOnReportsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDriveOnReportsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDriveOnReports>>, TError = AxiosError<unknown>>(params: GetDriveOnReportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReports>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDriveOnReportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriveOnReports>>> = ({ signal }) => getDriveOnReports(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDriveOnReportsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDriveOnReports>>>
export type GetDriveOnReportsSuspenseQueryError = AxiosError<unknown>


export function useGetDriveOnReportsSuspense<TData = Awaited<ReturnType<typeof getDriveOnReports>>, TError = AxiosError<unknown>>(
 params: GetDriveOnReportsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReports>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriveOnReportsSuspense<TData = Awaited<ReturnType<typeof getDriveOnReports>>, TError = AxiosError<unknown>>(
 params: GetDriveOnReportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReports>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriveOnReportsSuspense<TData = Awaited<ReturnType<typeof getDriveOnReports>>, TError = AxiosError<unknown>>(
 params: GetDriveOnReportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReports>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDriveOnReportsSuspense<TData = Awaited<ReturnType<typeof getDriveOnReports>>, TError = AxiosError<unknown>>(
 params: GetDriveOnReportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReports>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDriveOnReportsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createDriveOnReport = (
    params: CreateDriveOnReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    
    return axios.default.post(
      `/api/driveon/report`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getCreateDriveOnReportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDriveOnReport>>, TError,{params: CreateDriveOnReportParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createDriveOnReport>>, TError,{params: CreateDriveOnReportParams}, TContext> => {
    
const mutationKey = ['createDriveOnReport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDriveOnReport>>, {params: CreateDriveOnReportParams}> = (props) => {
          const {params} = props ?? {};

          return  createDriveOnReport(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDriveOnReportMutationResult = NonNullable<Awaited<ReturnType<typeof createDriveOnReport>>>
    
    export type CreateDriveOnReportMutationError = AxiosError<unknown>

    export const useCreateDriveOnReport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDriveOnReport>>, TError,{params: CreateDriveOnReportParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createDriveOnReport>>,
        TError,
        {params: CreateDriveOnReportParams},
        TContext
      > => {

      const mutationOptions = getCreateDriveOnReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const logoutFromTarget = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/driveon/driver/logout`,undefined,options
    );
  }



export const getLogoutFromTargetMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutFromTarget>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof logoutFromTarget>>, TError,void, TContext> => {
    
const mutationKey = ['logoutFromTarget'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutFromTarget>>, void> = () => {
          

          return  logoutFromTarget(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutFromTargetMutationResult = NonNullable<Awaited<ReturnType<typeof logoutFromTarget>>>
    
    export type LogoutFromTargetMutationError = AxiosError<unknown>

    export const useLogoutFromTarget = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutFromTarget>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof logoutFromTarget>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getLogoutFromTargetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Change the selected target's driver
 */
export const changeTarget = (
    params: ChangeTargetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.post(
      `/api/driveon/driver/change`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getChangeTargetMutationOptions = <TError = AxiosError<DriveOnAuthTemplateNotFoundException | DriveOnTargetAlreadyAssignedException>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeTarget>>, TError,{params: ChangeTargetParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof changeTarget>>, TError,{params: ChangeTargetParams}, TContext> => {
    
const mutationKey = ['changeTarget'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeTarget>>, {params: ChangeTargetParams}> = (props) => {
          const {params} = props ?? {};

          return  changeTarget(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeTargetMutationResult = NonNullable<Awaited<ReturnType<typeof changeTarget>>>
    
    export type ChangeTargetMutationError = AxiosError<DriveOnAuthTemplateNotFoundException | DriveOnTargetAlreadyAssignedException>

    /**
 * @summary Change the selected target's driver
 */
export const useChangeTarget = <TError = AxiosError<DriveOnAuthTemplateNotFoundException | DriveOnTargetAlreadyAssignedException>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeTarget>>, TError,{params: ChangeTargetParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof changeTarget>>,
        TError,
        {params: ChangeTargetParams},
        TContext
      > => {

      const mutationOptions = getChangeTargetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getLatestDriveOnDriverInput = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DriveOnStatusDto>> => {
    
    
    return axios.default.get(
      `/api/driveon/driverInput`,options
    );
  }


export const getGetLatestDriveOnDriverInputQueryKey = () => {
    return [`/api/driveon/driverInput`] as const;
    }

    
export const getGetLatestDriveOnDriverInputQueryOptions = <TData = Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestDriveOnDriverInputQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>> = ({ signal }) => getLatestDriveOnDriverInput({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLatestDriveOnDriverInputQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>>
export type GetLatestDriveOnDriverInputQueryError = AxiosError<unknown>


export function useGetLatestDriveOnDriverInput<TData = Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>,
          TError,
          Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestDriveOnDriverInput<TData = Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>,
          TError,
          Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestDriveOnDriverInput<TData = Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLatestDriveOnDriverInput<TData = Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLatestDriveOnDriverInputQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetLatestDriveOnDriverInputSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestDriveOnDriverInputQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>> = ({ signal }) => getLatestDriveOnDriverInput({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLatestDriveOnDriverInputSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>>
export type GetLatestDriveOnDriverInputSuspenseQueryError = AxiosError<unknown>


export function useGetLatestDriveOnDriverInputSuspense<TData = Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestDriveOnDriverInputSuspense<TData = Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestDriveOnDriverInputSuspense<TData = Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLatestDriveOnDriverInputSuspense<TData = Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLatestDriveOnDriverInput>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLatestDriveOnDriverInputSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Patch data from client
 */
export const patchDriverInput = (
    driveOnDriverInputPatchDto: DriveOnDriverInputPatchDto,
    params: PatchDriverInputParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.patch(
      `/api/driveon/driverInput`,
      driveOnDriverInputPatchDto,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPatchDriverInputMutationOptions = <TError = AxiosError<DriveOnAuthTemplateNotFoundException | DriveOnTargetIdentificationException>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchDriverInput>>, TError,{data: DriveOnDriverInputPatchDto;params: PatchDriverInputParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof patchDriverInput>>, TError,{data: DriveOnDriverInputPatchDto;params: PatchDriverInputParams}, TContext> => {
    
const mutationKey = ['patchDriverInput'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchDriverInput>>, {data: DriveOnDriverInputPatchDto;params: PatchDriverInputParams}> = (props) => {
          const {data,params} = props ?? {};

          return  patchDriverInput(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchDriverInputMutationResult = NonNullable<Awaited<ReturnType<typeof patchDriverInput>>>
    export type PatchDriverInputMutationBody = DriveOnDriverInputPatchDto
    export type PatchDriverInputMutationError = AxiosError<DriveOnAuthTemplateNotFoundException | DriveOnTargetIdentificationException>

    /**
 * @summary Patch data from client
 */
export const usePatchDriverInput = <TError = AxiosError<DriveOnAuthTemplateNotFoundException | DriveOnTargetIdentificationException>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchDriverInput>>, TError,{data: DriveOnDriverInputPatchDto;params: PatchDriverInputParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof patchDriverInput>>,
        TError,
        {data: DriveOnDriverInputPatchDto;params: PatchDriverInputParams},
        TContext
      > => {

      const mutationOptions = getPatchDriverInputMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getTasks = (
    params?: GetTasksParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DriveOnDisplayableTaskDto[]>> => {
    
    
    return axios.default.get(
      `/api/driveon/tasks`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetTasksQueryKey = (params?: GetTasksParams,) => {
    return [`/api/driveon/tasks`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTasksQueryOptions = <TData = Awaited<ReturnType<typeof getTasks>>, TError = AxiosError<unknown>>(params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasks>>> = ({ signal }) => getTasks(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getTasks>>>
export type GetTasksQueryError = AxiosError<unknown>


export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = AxiosError<unknown>>(
 params: undefined |  GetTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = AxiosError<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = AxiosError<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = AxiosError<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTasksSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTasks>>, TError = AxiosError<unknown>>(params?: GetTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasks>>> = ({ signal }) => getTasks(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTasks>>>
export type GetTasksSuspenseQueryError = AxiosError<unknown>


export function useGetTasksSuspense<TData = Awaited<ReturnType<typeof getTasks>>, TError = AxiosError<unknown>>(
 params: undefined |  GetTasksParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksSuspense<TData = Awaited<ReturnType<typeof getTasks>>, TError = AxiosError<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksSuspense<TData = Awaited<ReturnType<typeof getTasks>>, TError = AxiosError<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTasksSuspense<TData = Awaited<ReturnType<typeof getTasks>>, TError = AxiosError<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTargets = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DriveOnTargetsDto>> => {
    
    
    return axios.default.get(
      `/api/driveon/targets`,options
    );
  }


export const getGetTargetsQueryKey = () => {
    return [`/api/driveon/targets`] as const;
    }

    
export const getGetTargetsQueryOptions = <TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargets>>> = ({ signal }) => getTargets({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof getTargets>>>
export type GetTargetsQueryError = AxiosError<unknown>


export function useGetTargets<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargets>>,
          TError,
          Awaited<ReturnType<typeof getTargets>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargets<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargets>>,
          TError,
          Awaited<ReturnType<typeof getTargets>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargets<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTargets<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargetsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTargetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargets>>> = ({ signal }) => getTargets({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTargets>>>
export type GetTargetsSuspenseQueryError = AxiosError<unknown>


export function useGetTargetsSuspense<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetsSuspense<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetsSuspense<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTargetsSuspense<TData = Awaited<ReturnType<typeof getTargets>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargetsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTargetsWithDistance = (
    params: GetTargetsWithDistanceParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DriveOnNearestTargetsDto>> => {
    
    
    return axios.default.get(
      `/api/driveon/targets/distance`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetTargetsWithDistanceQueryKey = (params: GetTargetsWithDistanceParams,) => {
    return [`/api/driveon/targets/distance`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTargetsWithDistanceQueryOptions = <TData = Awaited<ReturnType<typeof getTargetsWithDistance>>, TError = AxiosError<unknown>>(params: GetTargetsWithDistanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetsWithDistance>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetsWithDistanceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargetsWithDistance>>> = ({ signal }) => getTargetsWithDistance(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTargetsWithDistance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargetsWithDistanceQueryResult = NonNullable<Awaited<ReturnType<typeof getTargetsWithDistance>>>
export type GetTargetsWithDistanceQueryError = AxiosError<unknown>


export function useGetTargetsWithDistance<TData = Awaited<ReturnType<typeof getTargetsWithDistance>>, TError = AxiosError<unknown>>(
 params: GetTargetsWithDistanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetsWithDistance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargetsWithDistance>>,
          TError,
          Awaited<ReturnType<typeof getTargetsWithDistance>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetsWithDistance<TData = Awaited<ReturnType<typeof getTargetsWithDistance>>, TError = AxiosError<unknown>>(
 params: GetTargetsWithDistanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetsWithDistance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargetsWithDistance>>,
          TError,
          Awaited<ReturnType<typeof getTargetsWithDistance>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetsWithDistance<TData = Awaited<ReturnType<typeof getTargetsWithDistance>>, TError = AxiosError<unknown>>(
 params: GetTargetsWithDistanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetsWithDistance>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTargetsWithDistance<TData = Awaited<ReturnType<typeof getTargetsWithDistance>>, TError = AxiosError<unknown>>(
 params: GetTargetsWithDistanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetsWithDistance>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargetsWithDistanceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTargetsWithDistanceSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTargetsWithDistance>>, TError = AxiosError<unknown>>(params: GetTargetsWithDistanceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetsWithDistance>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetsWithDistanceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargetsWithDistance>>> = ({ signal }) => getTargetsWithDistance(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetsWithDistance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargetsWithDistanceSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTargetsWithDistance>>>
export type GetTargetsWithDistanceSuspenseQueryError = AxiosError<unknown>


export function useGetTargetsWithDistanceSuspense<TData = Awaited<ReturnType<typeof getTargetsWithDistance>>, TError = AxiosError<unknown>>(
 params: GetTargetsWithDistanceParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetsWithDistance>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetsWithDistanceSuspense<TData = Awaited<ReturnType<typeof getTargetsWithDistance>>, TError = AxiosError<unknown>>(
 params: GetTargetsWithDistanceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetsWithDistance>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetsWithDistanceSuspense<TData = Awaited<ReturnType<typeof getTargetsWithDistance>>, TError = AxiosError<unknown>>(
 params: GetTargetsWithDistanceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetsWithDistance>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTargetsWithDistanceSuspense<TData = Awaited<ReturnType<typeof getTargetsWithDistance>>, TError = AxiosError<unknown>>(
 params: GetTargetsWithDistanceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetsWithDistance>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargetsWithDistanceSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDriveOnReportReadyStateById = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    
    
    return axios.default.get(
      `/api/driveon/report/${id}`,options
    );
  }


export const getGetDriveOnReportReadyStateByIdQueryKey = (id: string,) => {
    return [`/api/driveon/report/${id}`] as const;
    }

    
export const getGetDriveOnReportReadyStateByIdQueryOptions = <TData = Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError = AxiosError<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDriveOnReportReadyStateByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>> = ({ signal }) => getDriveOnReportReadyStateById(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDriveOnReportReadyStateByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>>
export type GetDriveOnReportReadyStateByIdQueryError = AxiosError<unknown>


export function useGetDriveOnReportReadyStateById<TData = Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError = AxiosError<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>,
          TError,
          Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriveOnReportReadyStateById<TData = Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>,
          TError,
          Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriveOnReportReadyStateById<TData = Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDriveOnReportReadyStateById<TData = Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDriveOnReportReadyStateByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDriveOnReportReadyStateByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError = AxiosError<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDriveOnReportReadyStateByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>> = ({ signal }) => getDriveOnReportReadyStateById(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDriveOnReportReadyStateByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>>
export type GetDriveOnReportReadyStateByIdSuspenseQueryError = AxiosError<unknown>


export function useGetDriveOnReportReadyStateByIdSuspense<TData = Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError = AxiosError<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriveOnReportReadyStateByIdSuspense<TData = Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriveOnReportReadyStateByIdSuspense<TData = Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDriveOnReportReadyStateByIdSuspense<TData = Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportReadyStateById>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDriveOnReportReadyStateByIdSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDriveOnReportResult = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    
    return axios.default.get(
      `/api/driveon/report/${id}/result`,options
    );
  }


export const getGetDriveOnReportResultQueryKey = (id: string,) => {
    return [`/api/driveon/report/${id}/result`] as const;
    }

    
export const getGetDriveOnReportResultQueryOptions = <TData = Awaited<ReturnType<typeof getDriveOnReportResult>>, TError = AxiosError<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportResult>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDriveOnReportResultQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriveOnReportResult>>> = ({ signal }) => getDriveOnReportResult(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportResult>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDriveOnReportResultQueryResult = NonNullable<Awaited<ReturnType<typeof getDriveOnReportResult>>>
export type GetDriveOnReportResultQueryError = AxiosError<unknown>


export function useGetDriveOnReportResult<TData = Awaited<ReturnType<typeof getDriveOnReportResult>>, TError = AxiosError<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportResult>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriveOnReportResult>>,
          TError,
          Awaited<ReturnType<typeof getDriveOnReportResult>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriveOnReportResult<TData = Awaited<ReturnType<typeof getDriveOnReportResult>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportResult>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriveOnReportResult>>,
          TError,
          Awaited<ReturnType<typeof getDriveOnReportResult>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriveOnReportResult<TData = Awaited<ReturnType<typeof getDriveOnReportResult>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportResult>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDriveOnReportResult<TData = Awaited<ReturnType<typeof getDriveOnReportResult>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportResult>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDriveOnReportResultQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDriveOnReportResultSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDriveOnReportResult>>, TError = AxiosError<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportResult>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDriveOnReportResultQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriveOnReportResult>>> = ({ signal }) => getDriveOnReportResult(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportResult>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDriveOnReportResultSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDriveOnReportResult>>>
export type GetDriveOnReportResultSuspenseQueryError = AxiosError<unknown>


export function useGetDriveOnReportResultSuspense<TData = Awaited<ReturnType<typeof getDriveOnReportResult>>, TError = AxiosError<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportResult>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriveOnReportResultSuspense<TData = Awaited<ReturnType<typeof getDriveOnReportResult>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportResult>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriveOnReportResultSuspense<TData = Awaited<ReturnType<typeof getDriveOnReportResult>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportResult>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDriveOnReportResultSuspense<TData = Awaited<ReturnType<typeof getDriveOnReportResult>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriveOnReportResult>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDriveOnReportResultSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



